import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {
    ProductResponse,
    RoutingProductPurchaseRequest,
    RoutingProductPurchaseResponse
} from 'src/app/models/product.model';

import { ResponseObject } from 'src/app/models/response-object.model';
import { ProductRoutingService } from 'src/app/services/product-routing.service';
import { ProductService } from 'src/app/services/product.service';

@Component({
    selector: 'app-product-routing-purchases',
    templateUrl: './product-routing-purchases.component.html',
    styleUrls: ['./product-routing-purchases.component.scss']
})
export class ProductRoutingPurchasesComponent implements OnInit {

    inputs = {
        productPurchase: {
            value: null,
            verified: false,
            required: false,
            message: 'Campo requerido',
            class: 'fa-list',
            color: '',
            tooltip: '',
            data: { id: null }
        },
        productOC: {
            value: null,
            verified: false,
            required: false,
            message: 'Campo requerido',
            class: 'fa-list',
            color: '',
            tooltip: '',
            data: { id: null }
        }
    };

    filterProductsPurchase: ProductResponse[] = [];
    filterProductsOC: ProductResponse[] = [];

    routingProductPurchaseList: RoutingProductPurchaseResponse[] = [];

    timeoutPurchase: any = null;
    timeoutOC: any = null;

    deleting: { [key: number]: boolean } = {};
    saving: boolean = false;

    constructor(
        private productRoutingService: ProductRoutingService,
        private productService: ProductService,
        private toastService: ToastrService
    ) { }

    ngOnInit(): void {
        this.getProducts('', this.inputs.productPurchase, 'purchase');
        this.getProducts('', this.inputs.productOC, 'oc');
        this.getAllRoutings();
    }

    changeInput(
        input: any,
        value: any,
        verified: boolean,
        required: boolean,
        classIcon: string,
        data: any
    ) {
        input.value = value !== undefined ? value : input.value;

        input.verified = verified !== undefined && verified !== null
            ? verified
            : input.verified;

        input.required = required !== undefined && required !== null
            ? required
            : input.required;

        input.class = classIcon || input.class;

        if (data !== undefined) {
            input.data = data;
        }
    }

    getProducts(
        clue: string,
        inputRef: any,
        target: 'purchase' | 'oc'
    ) {
        this.productService.getProducts(clue).subscribe({
            next: (response: ResponseObject) => {

                const list: ProductResponse[] = response.data || [];

                if (target === 'purchase') {
                    this.filterProductsPurchase = list;
                } else {
                    this.filterProductsOC = list;
                }

                if (list.length === 0) {
                    this.changeInput(
                        inputRef,
                        clue,
                        false,
                        null,
                        'fa-xmark',
                        { id: null }
                    );
                } else if (list.length === 1) {
                    this.changeInput(
                        inputRef,
                        list[0].code + ' - ' + list[0].name,
                        true,
                        null,
                        'fa-circle-check',
                        list[0]
                    );
                } else {
                    this.changeInput(
                        inputRef,
                        clue,
                        false,
                        null,
                        'fa-list',
                        { id: null }
                    );
                }
            },
            error: (err: HttpErrorResponse) => {
                console.error('Error obteniendo productos:', err);
            }
        });
    }

    writeProductPurchase(inputEvent: any) {
        const inputValue = inputEvent.target.value;

        clearTimeout(this.timeoutPurchase);

        this.inputs.productPurchase.value = inputValue;
        this.inputs.productPurchase.verified = false;
        this.inputs.productPurchase.data = { id: null };
        this.inputs.productPurchase.class = 'typing';

        this.timeoutPurchase = setTimeout(() => {
            this.getProducts(
                inputValue,
                this.inputs.productPurchase,
                'purchase'
            );
        }, 500);
    }

    writeProductOC(inputEvent: any) {
        const inputValue = inputEvent.target.value;

        clearTimeout(this.timeoutOC);

        this.inputs.productOC.value = inputValue;
        this.inputs.productOC.verified = false;
        this.inputs.productOC.data = { id: null };
        this.inputs.productOC.class = 'typing';

        this.timeoutOC = setTimeout(() => {
            this.getProducts(
                inputValue,
                this.inputs.productOC,
                'oc'
            );
        }, 500);
    }

    checkProductPurchase(product: ProductResponse) {
        clearTimeout(this.timeoutPurchase);

        this.changeInput(
            this.inputs.productPurchase,
            product.code + ' - ' + product.name,
            true,
            null,
            'fa-circle-check',
            product
        );
    }

    checkProductOC(product: ProductResponse) {
        clearTimeout(this.timeoutOC);

        this.changeInput(
            this.inputs.productOC,
            product.code + ' - ' + product.name,
            true,
            null,
            'fa-circle-check',
            product
        );
    }

    reset() {
        clearTimeout(this.timeoutPurchase);
        clearTimeout(this.timeoutOC);

        this.inputs.productPurchase.value = null;
        this.inputs.productPurchase.verified = false;
        this.inputs.productPurchase.class = 'fa-list';
        this.inputs.productPurchase.data = { id: null };

        this.inputs.productOC.value = null;
        this.inputs.productOC.verified = false;
        this.inputs.productOC.class = 'fa-list';
        this.inputs.productOC.data = { id: null };

        this.filterProductsPurchase = [];
        this.filterProductsOC = [];
    }

    getAllRoutings() {
        this.productRoutingService.getAllPurchase().subscribe({
            next: (response: ResponseObject) => {
                this.routingProductPurchaseList = response.data || [];
            },
            error: (err: HttpErrorResponse) => {
                this.toastService.error(
                    err?.error?.message ||
                    'No se pudieron obtener los routings de compras',
                    'Error'
                );
                console.error(err);
            }
        });
    }

    saveRouting() {
        const productPurchaseId = this.inputs.productPurchase.data?.id;
        const productOCId = this.inputs.productOC.data?.id;

        if (
            !productPurchaseId ||
            !productOCId ||
            !this.inputs.productPurchase.verified ||
            !this.inputs.productOC.verified
        ) {
            this.toastService.warning(
                'Debes seleccionar ambos productos',
                'Validación'
            );
            return;
        }

        if (this.saving) {
            return;
        }

        const payload: RoutingProductPurchaseRequest = {
            productPurchase: productPurchaseId,
            productOC: productOCId
        };

        this.saving = true;

        this.productRoutingService.createPurchase(payload).subscribe({
            next: () => {
                this.toastService.success(
                    'Routing de compras guardado correctamente',
                    'Éxito'
                );

                this.reset();
                this.getAllRoutings();
                this.saving = false;
            },
            error: (err: HttpErrorResponse) => {
                this.toastService.error(
                    err?.error?.message ||
                    'No se pudo guardar el routing de compras',
                    'Error'
                );

                console.error(err);
                this.saving = false;
            }
        });
    }

    deleteRouting(id: number) {
        if (this.deleting[id]) {
            return;
        }

        this.deleting[id] = true;

        this.productRoutingService.deletePurchase(id).subscribe({
            next: () => {
                this.toastService.success(
                    'Routing de compras eliminado correctamente',
                    'Éxito'
                );

                this.getAllRoutings();
                this.deleting[id] = false;
            },
            error: (err: HttpErrorResponse) => {
                this.toastService.error(
                    err?.error?.message ||
                    'No se pudo eliminar el routing de compras',
                    'Error'
                );

                console.error(err);
                this.deleting[id] = false;
            }
        });
    }
}
